export default __webpack_public_path__ + "static/frame-4ecda8c811cc05f705054780b8039a31.png";